import { JsonObject, JsonProperty } from 'json2typescript';
import { ModelEntity, UtilsString } from '@pit/core';
import { IDtoCustomer } from '../interfaces/dto.customer.interface';
import { IDtoMandator } from '../interfaces/dto.mandator.interface';
import { DtoMandator } from './dto.mandator';
import { IDtoCustomerTransferTime } from '../interfaces/dto.customer.transfertime.interface';
import { DtoCustomerTransferTime } from './dto.customer.transfertime';

// @dynamic
@JsonObject('DtoCustomer')
export class DtoCustomer extends ModelEntity implements IDtoCustomer {

    constructor(initValues: Partial<IDtoCustomer> = null) {
        super();

        if (initValues !== null) {
            Object.assign(this, initValues);
        }
    }

    @JsonProperty('name', String, true)
    public name?: string = null;

    @JsonProperty('numberCustomer', String, true)
    public numberCustomer?: string = null;

    @JsonProperty('costCenterCode', String, true)
    public costCenterCode?: string = null;

    @JsonProperty('mandator', DtoMandator, true)
    public mandator?: IDtoMandator = null;

    @JsonProperty('transferTimes', [DtoCustomerTransferTime], true)
    public transferTimes?: IDtoCustomerTransferTime[] = [];

}
